
import React, { Fragment } from 'react';

// Utils

import { appendClassNames } from '../../../../../utils/miscellaneous/appendClassNames';




const GridItem = props => {

    const {
        items
    } = props;

    const getColumnsQty = qty => {

        // classes are handled in _income_summary.scss

        switch(qty) {
            case 3:
                return 'three';
            case 4:
                return 'four';
            case 5:
                return 'five';
            default:
                return '';
        }
    };

    return (
        <Fragment>
            {
                items.map((item, i, arr) => {

                    const {
                        value,
                        className,
                    } = item;

                    return (
                        <span
                            key = { i }
                            className = { appendClassNames(className, getColumnsQty(arr.length)) }
                        >
                            { value }
                        </span>
                    );
                })
            }
        </Fragment>
    );
};

export default GridItem;